export const environment = {
  production: false,
  baseUrl: 'https://dev-api.valvur.gg',
  stripePublicKey: 'pk_test_eXhsV7Q9QW7gXfr8nguf8gJU008y8rsM4c',
  googleClientId:
    '959903953413-j9igme9frplh7unq050hjl9eubuimhkr.apps.googleusercontent.com',
  /** GA4 Measurement ID for local/dev stream (create a dedicated Dev stream in GA). */
  gaMeasurementId: '',
  gtmContainerId: '',
};
